import { render, staticRenderFns } from "./CPanelHosting.vue?vue&type=template&id=4d1fbe36&"
import script from "./CPanelHosting.vue?vue&type=script&lang=js&"
export * from "./CPanelHosting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports